import gql from 'graphql-tag';

import { apolloClient } from 'core/apollo-client';

/**
 * Pauses / resumes Dialpad call recording (audio + screen + transcription) for the calling staff
 * agent's active call. Used while an internal agent has a payment-entry form (CC or ACH) open so
 * full card / bank-account numbers are never captured. See issue
 * https://github.com/gobranch/branch/issues/15438.
 *
 * The backend (staff-appsync-be `toggle-dialpad-recording` lambda) resolves the agent from the
 * Cognito identity and PATCHes their Dialpad active call; "no active call" is a benign no-op there.
 * These helpers are intentionally fire-and-forget and swallow errors — toggling recording must
 * never block an agent from entering payment information.
 */

const TOGGLE_DIALPAD_RECORDING = gql`
  mutation toggleDialpadRecording($args: ToggleDialpadRecordingInput!) {
    toggleDialpadRecording(args: $args) {
      success
      message
    }
  }
`;

const toggle = async (action) => {
  try {
    await apolloClient.mutate({
      mutation: TOGGLE_DIALPAD_RECORDING,
      variables: { args: { action } }
    });
  } catch (error) {
    // Never surface to the agent — recording control is best-effort.
    console.error(`Failed to ${action} Dialpad call recording`, error);
  }
};

export const pauseCallRecording = () => toggle('pause');
export const resumeCallRecording = () => toggle('resume');
